import { singleDownloadPdf } from '@/api/interFace'

export function parseFilenameFromDisposition(disposition) {
    if (!disposition) return ''
    const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
    if (utf8Match && utf8Match[1]) {
        try { return decodeURIComponent(utf8Match[1].replace(/"/g, '')) } catch (e) { /* ignore decode error */ }
        return utf8Match[1].replace(/"/g, '')
    }
    const match = disposition.match(/filename\s*=\s*("?)([^";]+)\1/i)
    return match && match[2] ? match[2] : ''
}

export function downloadBlob(blob, filename) {
    const name = filename || '下载文件'
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = name
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
}

export function readBlobAsText(blob) {
    return new Promise(resolve => {
        try {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result || '')
            reader.onerror = () => resolve('')
            reader.readAsText(blob)
        } catch (e) {
            resolve('')
        }
    })
}

/** blob 下载接口失败时可能仍返回 JSON（如 code:400），解析出 msg */
export async function getBlobErrorMsg(blob) {
    if (!blob) return ''
    // 过大的响应基本是文件流，跳过解析
    if (blob.size > 1024 * 100) return ''
    const text = await readBlobAsText(blob)
    if (!text) return ''
    try {
        const json = JSON.parse(text)
        if (!json || typeof json !== 'object') return ''
        if (json.code !== undefined && Number(json.code) !== 200) {
            return json.msg || json.message || '下载失败'
        }
    } catch (e) {
        // 非 JSON，忽略
    }
    return ''
}

/**
 * 单份合同 PDF 下载（后端返回文件流）
 * @param {{ contractId: number|string, contractName?: string }} options
 * @throws {{ msg: string }} 业务或网络错误
 */
export async function downloadSingleContractPdf({ contractId, contractName } = {}) {
    if (!contractId) {
        throw { msg: '参数错误' }
    }
    try {
        const res = await singleDownloadPdf({ contract_id: contractId })
        const blob = res && res.data
        const headers = (res && res.headers) || {}
        const contentType = (headers['content-type'] || headers['Content-Type'] || '').toLowerCase()

        const errMsg = await getBlobErrorMsg(blob)
        if (errMsg || contentType.includes('application/json') || contentType.includes('text/plain')) {
            throw { msg: errMsg || '下载失败' }
        }

        const headerFilename = parseFilenameFromDisposition(headers['content-disposition'] || headers['Content-Disposition'])
        const filename = headerFilename || `${contractName || '合同'}.pdf`
        downloadBlob(blob, filename)
    } catch (e) {
        if (e && e.msg) throw e
        const errBlob = e && e.response && e.response.data
        if (errBlob instanceof Blob) {
            const errMsg = await getBlobErrorMsg(errBlob)
            throw { msg: errMsg || '下载失败，请重试' }
        }
        throw { msg: (e && e.message) || '下载失败，请重试' }
    }
}
